// const baseUrl ="http://www.onlinedevelop.in/api/";
const baseUrl = "https://www.mawj.dev/api/";

export { baseUrl}